<script setup lang="ts">
// Page-end pieces of the desktop shell: the collapsed FAQ entry (home only, kept for search engines) and the
// transparency links with the ICP filing number.
import { FAQ_ENTRY_ITEMS } from '../areas/home/home-copy'

defineProps<{ showFaq: boolean }>()
</script>

<template>
  <section v-if="showFaq" class="geo-faq" id="faq" aria-label="备考常见问题">
    <details class="geo-faq-panel">
      <summary class="geo-faq-entry"><span>备考常见问题</span><small>{{ FAQ_ENTRY_ITEMS.length }} 个简明问答</small></summary>
      <div class="geo-faq-content">
        <h2>常见问题</h2>
        <div class="geo-faq-list">
          <details v-for="item in FAQ_ENTRY_ITEMS" :key="item.q" class="geo-faq-item"><summary>{{ item.q }}</summary><p>{{ item.a }}</p></details>
        </div>
      </div>
    </details>
  </section>
  <footer class="sb-icp" style="text-align:center;padding:6px 16px 10px;font:11px/1.4 -apple-system,'PingFang SC',sans-serif;color:#5f7480">
    <nav aria-label="内容透明度" style="display:flex;justify-content:center;flex-wrap:wrap;gap:4px 12px;margin-bottom:2px">
      <a href="/methodology/">内容方法</a><a href="/changelog/">更新日志</a><a href="/about/">关于我们</a><a href="/editorial-policy/">编辑规范</a>
    </nav>
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">赣ICP备2026000866号-2</a>
  </footer>
</template>
